import { Component, OnChanges, OnInit, Input } from '@angular/core';
import { EChartsOption } from 'echarts';
import {
	THEME_COLOR_BLUE,
	THEME_COLOR_GREEN,
	THEME_COLOR_MAIN,
	THEME_COLOR_PINK
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { DateUtils } from 'src/app/shared/utils/date-utils';

@Component({
	selector: 'app-working-time-by-user',
	templateUrl: './working-time-by-user.component.html',
	styleUrls: ['./working-time-by-user.component.scss']
})
export class WorkingTimeByUserComponent implements OnChanges {
	workingTime: EChartsOption;
	workingAndTravelTime: EChartsOption;
	workingTravelAndAdministrativeTime: EChartsOption;
	@Input() statGlobal?: any = [];
	@Input() statLpc?: any = [];
	@Input() statLds?: any = [];
	@Input() statPriseDeNote?: any = [];
	@Input() statsEmployee?: any = [];
	userNameArray = []; //Tableau de nom des employés
	faceToFaceTime = []; //Tableau du Temps de prestation
	travelTime = []; //Tableau du temps de trajet
	administrativeTime = []; //Tableau du temps administratif

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	constructor(public dateutil: DateUtils, private facade: FacadeService) {
		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
	}

	// ngOnInit(): void {}

	ngOnChanges() {
		if (isNaN(this.statsEmployee)) {
			try {
				this.updateUserName();
				this.updateChart();
			} catch (error) {}
		}
	}

	updateChart() {
		const xAxisData = this.userNameArray;
		this.workingTime = {
			legend: {
				data: this.isSESSAD
					? [
							'Temps de prestation',
							'Temps de deplacement',
							'Temps administratif'
					  ]
					: ['Temps de prestation', 'Temps de deplacement'],
				align: 'left',
				textStyle: { color: THEME_COLOR_MAIN }
			},
			tooltip: {
				trigger: 'item',
				formatter: function (params) {
					const dateutil = new DateUtils();
					return (
						'<strong>' +
						params.name +
						'</strong>' +
						' :  ' +
						dateutil.timeConvert(params.value)
					);
				}
			},
			xAxis: {
				name: 'Employés',
				nameLocation: 'middle',
				nameGap: 50,
				data: xAxisData.map((e) => {
					return { value: e, textStyle: { color: THEME_COLOR_MAIN } };
				}),
				silent: false,
				splitLine: {
					show: false
				},
				nameTextStyle: { color: THEME_COLOR_MAIN }
			},
			yAxis: {
				type: 'value',
				axisLabel: {
					formatter: function (value) {
						const dateutil = new DateUtils();
						return dateutil.timeConvert(value);
					},
					color: THEME_COLOR_MAIN
				},
				name: 'Temps (heure)',
				nameLocation: 'middle',
				nameGap: 50,
				nameTextStyle: { color: THEME_COLOR_MAIN }
			},

			series: this.isSESSAD
				? [
						{
							name: 'Temps administratif',
							type: 'bar',
							data: this.administrativeTime,
							itemStyle: { color: THEME_COLOR_PINK },
							animationDelay: (idx) => idx * 10 + 100
						},
						{
							name: 'Temps de deplacement',
							type: 'bar',
							data: this.travelTime,
							itemStyle: { color: THEME_COLOR_BLUE },
							animationDelay: (idx) => idx * 10 + 100
						},
						{
							name: 'Temps de prestation',
							type: 'bar',
							data: this.faceToFaceTime,
							itemStyle: { color: THEME_COLOR_GREEN },
							animationDelay: (idx) => idx * 10 + 100
						}
				  ]
				: [
						{
							name: 'Temps de deplacement',
							type: 'bar',
							data: this.travelTime,
							itemStyle: { color: THEME_COLOR_BLUE },
							animationDelay: (idx) => idx * 10 + 100
						},
						{
							name: 'Temps de prestation',
							type: 'bar',
							data: this.faceToFaceTime,
							itemStyle: { color: THEME_COLOR_GREEN },
							animationDelay: (idx) => idx * 10 + 100
						}
				  ],
			animationEasing: 'elasticOut',
			animationDelayUpdate: (idx) => idx * 5
		};

		this.workingAndTravelTime = {
			legend: {
				data: this.isSESSAD
					? [
							'Temps de prestation',
							'Temps de prestation + Temps de deplacement',
							'Temps de prestation + Temps de deplacement + Temps administratif'
					  ]
					: [
							'Temps de prestation',
							'Temps de prestation + Temps de deplacement'
					  ],
				align: 'left',
				textStyle: { color: THEME_COLOR_MAIN }
			},
			tooltip: {
				trigger: 'item',
				formatter: function (params) {
					const dateutil = new DateUtils();
					return (
						'<strong>' +
						params.name +
						'</strong>' +
						' :  ' +
						dateutil.timeConvert(params.value)
					);
				}
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				data: xAxisData.map((e) => {
					return { value: e, textStyle: { color: THEME_COLOR_MAIN } };
				}),
				name: 'Employés',
				nameLocation: 'middle',
				nameGap: 50,
				nameTextStyle: { color: THEME_COLOR_MAIN }
			},
			yAxis: {
				type: 'value',
				nameTextStyle: { color: THEME_COLOR_MAIN },
				axisLabel: {
					formatter: function (value) {
						const dateutil = new DateUtils();
						return dateutil.timeConvert(value);
					},
					color: THEME_COLOR_MAIN
				},
				name: 'Temps (heure)',
				nameLocation: 'middle',
				nameGap: 50
			},
			series: this.isSESSAD
				? [
						{
							name: 'Temps de prestation + Temps de deplacement + Temps administratif',
							type: 'line',
							data: this.cumulTempsTotal(
								this.faceToFaceTime,
								this.travelTime,
								this.administrativeTime
							),
							animationDelay: (idx) => idx * 10 + 100,
							areaStyle: { color: THEME_COLOR_PINK },
							lineStyle: { color: THEME_COLOR_PINK },
							itemStyle: { color: THEME_COLOR_PINK }
						},
						{
							name: 'Temps de prestation + Temps de deplacement',
							type: 'line',
							data: this.cumulTemps(this.faceToFaceTime, this.travelTime),
							animationDelay: (idx) => idx * 10 + 100,
							areaStyle: { color: THEME_COLOR_BLUE },
							lineStyle: { color: THEME_COLOR_BLUE },
							itemStyle: { color: THEME_COLOR_BLUE }
						},
						{
							name: 'Temps de prestation',
							type: 'line',
							data: this.faceToFaceTime,
							animationDelay: (idx) => idx * 10 + 100,
							areaStyle: { color: THEME_COLOR_GREEN },
							lineStyle: { color: THEME_COLOR_GREEN },
							itemStyle: { color: THEME_COLOR_GREEN }
						}
				  ]
				: [
						{
							name: 'Temps de prestation + Temps de deplacement',
							type: 'line',
							data: this.cumulTemps(this.faceToFaceTime, this.travelTime),
							animationDelay: (idx) => idx * 10 + 100,
							areaStyle: { color: THEME_COLOR_BLUE },
							lineStyle: { color: THEME_COLOR_BLUE },
							itemStyle: { color: THEME_COLOR_BLUE }
						},
						{
							name: 'Temps de prestation',
							type: 'line',
							data: this.faceToFaceTime,
							animationDelay: (idx) => idx * 10 + 100,
							areaStyle: { color: THEME_COLOR_GREEN },
							lineStyle: { color: THEME_COLOR_GREEN },
							itemStyle: { color: THEME_COLOR_GREEN }
						}
				  ]
		};
	}

	updateUserName() {
		if (isNaN(this.statsEmployee)) {
			this.userNameArray = this.statsEmployee
				.filter((item) => item.fullName !== 'Total')
				.map((item) => {
					return item.fullName;
				});
			this.faceToFaceTime = this.statsEmployee
				.filter((item) => item.fullName !== 'Total')
				.map((item) => {
					return item.tempsFaceAFace;
				});

			this.travelTime = this.statsEmployee
				.filter((item) => item.fullName !== 'Total')
				.map((item) => {
					return item.tempsTrajet;
				});

			if (this.isSESSAD) {
				this.administrativeTime = this.statsEmployee
					.filter((item) => item.fullName !== 'Total')
					.map((item) => {
						return item.tempsAdministratifAndPreparation;
					});
			}
		}
	}

	cumulTemps(tab1: Array<number>, tab2: Array<number>) {
		const tab = [];
		tab1.forEach((value, index) => {
			tab.push(tab1[index] + tab2[index]);
		});
		return tab;
	}

	cumulTempsTotal(
		tab1: Array<number>,
		tab2: Array<number>,
		tab3: Array<number>
	) {
		const tab = [];
		tab1.forEach((value, index) => {
			tab.push(tab1[index] + tab2[index] + tab3[index]);
		});
		return tab;
	}
}
